import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import './styles/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import {
  VAlert,
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAppBarTitle,
  VAvatar,
  VBtn,
  VBtnToggle,
  VCard,
  VCardTitle,
  VChip,
  VCol,
  VContainer,
  VDivider,
  VIcon,
  VList,
  VListItem,
  VMain,
  VMenu,
  VNavigationDrawer,
  VRow,
  VSelect,
  VSpacer,
  VSwitch,
  VTab,
  VTable,
  VTabs,
  VTextarea,
  VTextField,
  VWindow,
  VWindowItem,
} from 'vuetify/components'
import * as directives from 'vuetify/directives'
import App from './App.vue'
import { router } from './router'

const vuetify = createVuetify({
  components: {
    VAlert,
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VAppBarTitle,
    VAvatar,
    VBtn,
    VBtnToggle,
    VCard,
    VCardTitle,
    VChip,
    VCol,
    VContainer,
    VDivider,
    VIcon,
    VList,
    VListItem,
    VMain,
    VMenu,
    VNavigationDrawer,
    VRow,
    VSelect,
    VSpacer,
    VSwitch,
    VTab,
    VTable,
    VTabs,
    VTextarea,
    VTextField,
    VWindow,
    VWindowItem,
  },
  directives,
  theme: {
    defaultTheme: 'pricechime',
    themes: {
      pricechime: {
        dark: false,
        colors: {
          background: '#f3f5ef',
          surface: '#fffdf7',
          primary: '#176b55',
          secondary: '#e5a229',
          accent: '#da5d3b',
          error: '#b42318',
          info: '#286c91',
        },
      },
    },
  },
  defaults: { VBtn: { rounded: 'lg', elevation: 0 }, VCard: { rounded: 'xl', elevation: 0 } },
})

createApp(App).use(createPinia()).use(router).use(vuetify).mount('#app')
